import { ModelCategory, RoofPlane } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';

export const RoofPlaneSchema = new ModelSchema<RoofPlane>('roofPlane', {
  category: ModelCategory.IntermediateModel,

  properties: {},
  children: {},
});
